import { getIterator } from "./iterables";
import { INIT, RESULT, STEP } from "./propertyNames";
import { isReduced, unreduced } from "./util";
export function transduce(collection, transform, reducer, initialValue) {
    var transformer;
    if (typeof reducer === "function") {
        // Type coercion because in this branch, TResult and TCompleteResult are
        // the same, but the checker doesn't know that.
        transformer = new ReducerWrappingTransformer(reducer, initialValue);
    }
    else {
        transformer = reducer;
    }
    return reduceWithTransformer(collection, transform(transformer));
}
function reduceWithTransformer(collection, f) {
    var uncompleteResult = reduceWithFunction(collection, f[STEP].bind(f), f[INIT]());
    return f[RESULT](unreduced(uncompleteResult));
}
export function reduceWithFunction(collection, f, initialValue) {
    var iterator = getIterator(collection);
    var result = initialValue;
    while (true) {
        var input = iterator.next();
        if (input.done) {
            return result;
        }
        var next = f(result, input.value);
        if (isReduced(next)) {
            return next;
        }
        else {
            result = next;
        }
    }
}
var ReducerWrappingTransformer = /**@__PURE__*/(function () {
    function ReducerWrappingTransformer(f, initialValue) {
        this.initialValue = initialValue;
        this[STEP] = f;
    }
    ReducerWrappingTransformer.prototype[INIT] = function () {
        return this.initialValue;
    };
    ReducerWrappingTransformer.prototype[RESULT] = function (result) {
        return result;
    };
    return ReducerWrappingTransformer;
}());
//# sourceMappingURL=core.js.map